import React from 'react'
import { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Head from 'next/head'

import { emptyForm } from '@/util/data'

import { Container } from '@/components/Container'
import { Footer } from '@/components/Footer'
import { Header } from '@/components/Header'
import { ContactHero } from '@/components/ContactHero'

export default function Contact() {
  const [formData, setformData] = useState(emptyForm)
  let newFormData = { ...formData }

  async function handleOnSubmit(e) {
    e.preventDefault()
    const formElements = e?.currentTarget?.elements
    const formObj = {}
    const formEleArray = Array.from(formElements)
    const honeypot = formEleArray.find((field) => {
      if (field.name === 'fullName' || field.name === 'workEmail') {
        return field.value.length > 0
      }
      return false
    })
    if (honeypot) return

    let response = await fetch('/api/mail', {
      method: 'post',
      body: JSON.stringify(formData),
    })
    if (!response.ok) {
      toast.error('🦄 Wow so easy!', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    } else {
      toast.success('🚀 Thanks! We will be contacting you soon.', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      setformData(emptyForm)
    }
    return
  }

  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="keywords" content="web design development application" />
        <title>
          EMP Development - Build a website that tells your story in an
          impactful way
        </title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta
          name="description"
          content="Web design and web application development agency contact"
        />
      </Head>
      <Header />
      <main>
        <Container className="pt-20 pb-16 text-center lg:pt-32">
          <ContactHero />

          <>
            <div className="relative flex w-full justify-center px-4 pb-16 sm:py-24 sm:px-6 lg:mx-auto lg:px-8 lg:py-2">
              <div className="lg:pr-8">
                <div className="mx-auto max-w-md sm:max-w-lg lg:mx-0">
                  <form
                    onSubmit={handleOnSubmit}
                    className="mt-9 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8"
                  >
                    <div>
                      <label
                        htmlFor="firstName"
                        className="block text-sm font-medium text-gray-700"
                      >
                        First name
                      </label>
                      <div className="mt-1">
                        <input
                          value={newFormData.firstName}
                          type="text"
                          name="firstName"
                          id="firstName"
                          autoComplete="given-name"
                          className="focus:border-grape-500 focus:ring-grape-500 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                          onChange={(e) => {
                            newFormData.firstName = e.target.value
                            setformData(newFormData)
                          }}
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="lastName"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Last name
                      </label>
                      <div className="mt-1">
                        <input
                          value={newFormData.lastName}
                          type="text"
                          name="lastName"
                          id="lastName"
                          autoComplete="family-name"
                          className="focus:border-grape-500 focus:ring-grape-500 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                          onChange={(e) => {
                            newFormData.lastName = e.target.value
                            setformData(newFormData)
                          }}
                        />
                      </div>
                    </div>
                    <div className="sm:col-span-2">
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Email
                      </label>
                      <div className="mt-1">
                        <input
                          value={newFormData.email}
                          id="email"
                          name="email"
                          type="email"
                          autoComplete="email"
                          className="focus:border-grape-500 focus:ring-grape-500 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                          onChange={(e) => {
                            newFormData.email = e.target.value
                            setformData(newFormData)
                          }}
                        />
                      </div>
                    </div>
                    <div className="sm:col-span-2">
                      <label
                        htmlFor="company"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Company
                      </label>
                      <div className="mt-1">
                        <input
                          value={newFormData.company}
                          type="text"
                          name="company"
                          id="company"
                          autoComplete="organization"
                          className="focus:border-grape-500 focus:ring-grape-500 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                          onChange={(e) => {
                            newFormData.company = e.target.value
                            setformData(newFormData)
                          }}
                        />
                      </div>
                    </div>
                    <div className="sm:col-span-2">
                      <div className="flex justify-between">
                        <label
                          htmlFor="phone"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Phone
                        </label>
                        <span
                          id="phone-description"
                          className="text-sm text-gray-500"
                        >
                          Optional
                        </span>
                      </div>
                      <div className="mt-1">
                        <input
                          value={newFormData.phone}
                          type="text"
                          name="phone"
                          id="phone"
                          autoComplete="tel"
                          aria-describedby="phone-description"
                          className="focus:border-grape-500 focus:ring-grape-500 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                          onChange={(e) => {
                            newFormData.phone = e.target.value
                            setformData(newFormData)
                          }}
                        />
                      </div>
                    </div>
                    <div className="sm:col-span-2">
                      <div className="flex justify-between">
                        <label
                          htmlFor="howCanWeHelp"
                          className="block text-sm font-medium text-gray-700"
                        >
                          How can we help you?
                        </label>
                        <span
                          id="how-can-we-help-description"
                          className="text-sm text-gray-500"
                        >
                          Max. 500 characters
                        </span>
                      </div>
                      <div className="mt-1">
                        <textarea
                          value={newFormData.howCanWeHelp}
                          id="howCanWeHelp"
                          name="howCanWeHelp"
                          aria-describedby="how-can-we-help-description"
                          rows={4}
                          className="focus:border-grape-500 focus:ring-grape-500 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                          onChange={(e) => {
                            newFormData.howCanWeHelp = e.target.value
                            setformData(newFormData)
                          }}
                        />
                      </div>
                    </div>

                    <div className="sm:col-span-2">
                      <label
                        htmlFor="howDidYouHearAboutUs"
                        className="block text-sm font-medium text-gray-700"
                      >
                        How did you hear about us?
                      </label>
                      <div className="mt-1">
                        <input
                          value={newFormData.howDidYouHearAboutUs}
                          type="text"
                          name="howDidYouHearAboutUs"
                          id="howDidYouHearAboutUs"
                          className="focus:border-grape-500 focus:ring-grape-500 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                          onChange={(e) => {
                            newFormData.howDidYouHearAboutUs = e.target.value
                            setformData(newFormData)
                          }}
                        />
                      </div>
                    </div>
                    <div className="absolute top-0 left-0 -z-50 h-0 w-0 opacity-0">
                      <label className="ohnohoney" htmlFor="fullName"></label>
                      <input
                        className="ohnohoney"
                        autoComplete="off"
                        type="text"
                        id="fullName"
                        name="fullName"
                        placeholder="Your full name here"
                      />
                      <label className="ohnohoney" htmlFor="workEmail"></label>
                      <input
                        className="ohnohoney"
                        autoComplete="off"
                        type="email"
                        id="workEmail"
                        name="workEmail"
                        placeholder="Your e-mail here"
                      ></input>
                    </div>
                    <div className="text-right sm:col-span-2">
                      <button
                        type="submit"
                        className="inline-flex justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </>
        </Container>
      </main>
      <Footer />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}
